import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { consentModule } from 'services/consent/consent_module'

const onetrustActiveGroupsSelector = (state) => state?.onetrust?.activeGroups

/**
 * Forwards OneTrust runtime state into the centralized embed consent module.
 *
 * Subscribes to the `onetrust.activeGroups` slice (populated by `@calendly/onetrust`'s
 * `Onetrust` component) and pushes it into `consentModule.updateFromOneTrust` whenever
 * it changes. When the slice is absent or transitions to a non-array value (e.g. the
 * slice is reset), the OneTrust signal is explicitly cleared with `null` so previously-
 * granted categories do not linger after the live source of truth has disappeared.
 * The previous `createIsOnetrustGroupOptedInSelector` read directly from the slice and
 * reflected removal immediately; this bridge preserves that semantic by mirroring the
 * slice's current value (including its absence) on every change.
 *
 * The module is idempotent: identical inputs (including `null → null`) produce no
 * `onChange` fires, so this is safe on initial mount when the slice has not yet been
 * populated.
 */
export const OnetrustConsentBridge = () => {
  const activeGroups = useSelector(onetrustActiveGroupsSelector)

  useEffect(() => {
    if (Array.isArray(activeGroups)) {
      consentModule.updateFromOneTrust({ activeGroups })
    } else {
      consentModule.updateFromOneTrust(null)
    }
  }, [activeGroups])

  return null
}
